export default "__VITE_ASSET__tJTS3sigk873lADtH2o4ZQ__"